import type { YouTubeProps } from "../../types";
import { IFrame } from "./components/IFrame";
export const YouTube = (props: YouTubeProps) => {
  return <IFrame src={`https://www.youtube.com/embed/${props.id}`} data-sentry-element="IFrame" data-sentry-component="YouTube" data-sentry-source-file="YouTube.tsx" />;
};